// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetCasePayorResponseModel {
    static getAttributeTypeMap() {
        return GetCasePayorResponseModel.attributeTypeMap;
    }
}
GetCasePayorResponseModel.discriminator = undefined;
GetCasePayorResponseModel.additionalProperties = false;
GetCasePayorResponseModel.attributeTypeMap = [
    {
        "name": "payorData",
        "baseName": "payorData",
        "type": "PayorModel"
    },
    {
        "name": "benefitData",
        "baseName": "benefitData",
        "type": "GetCasePayorResponseModelBenefitData"
    },
];
//# sourceMappingURL=getCasePayorResponseModel.js.map